module.exports = __webpack_public_path__ + "img/newpartner1.20cc2681.png";